/* assets/resource-post-home.js — Resource Post page behaviour. */

/* 1) Reading progress bar + table-of-contents active state */
(function(){
    var bar=document.getElementById('rpprog');
    var body=document.querySelector('.rpost .rpbody');
    var links=[].slice.call(document.querySelectorAll('.rptoc a'));
    var heads=links.map(function(a){ return document.querySelector(a.getAttribute('href')); });
    function onScroll(){
      if(body && bar){
        var r=body.getBoundingClientRect();
        var total=r.height - window.innerHeight + 120;
        var done=Math.min(Math.max(-r.top + 80, 0), Math.max(total,1));
        bar.style.width=(total>0 ? (done/total*100) : 0)+'%';
      }
      var idx=-1;
      for(var i=0;i<heads.length;i++){
        if(heads[i] && heads[i].getBoundingClientRect().top < 140) idx=i;
      }
      links.forEach(function(a,i){ a.classList.toggle('is-active', i===idx); });
    }
    window.addEventListener('scroll', onScroll, {passive:true});
    window.addEventListener('resize', onScroll);
    onScroll();
  })();

/* 2) Wire dead links, share buttons, related cards and the newsletter form */
(function(){
    var url = location.origin + location.pathname;
    var title = ((document.querySelector('.rphead h1')||{}).textContent || document.title || '').trim();

    /* on-page anchors that only exist on the home page -> point at the real destinations */
    document.querySelectorAll('a[href="#shop"]').forEach(function(a){ a.setAttribute('href','/#shop'); });
    document.querySelectorAll('a[href="#contact"]').forEach(function(a){ a.setAttribute('href','/pages/contact'); });

    /* share buttons: LinkedIn / email / copy-link */
    var sh = document.querySelectorAll('.rpshare a');
    if(sh[0]){ sh[0].setAttribute('href','https://www.linkedin.com/sharing/share-offsite/?url='+encodeURIComponent(url)); sh[0].setAttribute('target','_blank'); sh[0].setAttribute('rel','noopener noreferrer'); }
    if(sh[1]){ sh[1].setAttribute('href','mailto:?subject='+encodeURIComponent(title)+'&body='+encodeURIComponent(url)); }
    if(sh[2]){ sh[2].setAttribute('href','#'); sh[2].addEventListener('click', function(e){ e.preventDefault(); try{ navigator.clipboard.writeText(url); }catch(err){} var lbl=sh[2].getAttribute('aria-label'); sh[2].setAttribute('aria-label','Link copied'); sh[2].classList.add('is-copied'); setTimeout(function(){ sh[2].setAttribute('aria-label', lbl||'Copy link'); sh[2].classList.remove('is-copied'); }, 1600); }); }

    /* related ("Keep reading") cards left as href="#": resolve by their title */
    var map = {
      'audit':'firewall-audit-checklist','checklist to run':'firewall-audit-checklist',
      'utm':'what-a-utm-firewall-blocks',
      'malicious':'stop-malicious-links',
      'guest':'guest-wifi-segmentation',
      'evidence':'firewall-audit-evidence',
      'failover':'internet-failover-minutes','circuit':'internet-failover-minutes',
      'vpn':'secure-vpn-remote-access',
      'capacity':'right-size-firewall-capacity','right-siz':'right-size-firewall-capacity',
      'new-site':'new-site-firewall-checklist','deployment':'new-site-firewall-checklist',
      'operations':'managed-firewall-operations'
    };
    document.querySelectorAll('.rprel a.rsrc__card').forEach(function(card){
      var href=card.getAttribute('href');
      if(href && href!=='#') return;
      var t=((card.querySelector('.rsrc__t')||{}).textContent||'').replace(/\s+/g,' ').trim().toLowerCase();
      var found='';
      for(var k in map){ if(t.indexOf(k)>=0){ found=map[k]; break; } }
      if(found) card.setAttribute('href','/pages/'+found); else card.setAttribute('href','/pages/resources');
    });

    /* newsletter subscribe -> Shopify customer (marketing) signup via AJAX */
    document.querySelectorAll('.rnews__form').forEach(function(form){
      form.addEventListener('submit', function(e){
        e.preventDefault();
        var input=form.querySelector('input[type=email]');
        var email=input && input.value.trim();
        if(!email){ if(input) input.focus(); return; }
        var data=new URLSearchParams();
        data.append('form_type','customer'); data.append('utf8','\u2713');
        data.append('contact[email]',email); data.append('contact[tags]','newsletter,virtual-firewall');
        fetch('/contact',{method:'POST',headers:{'Content-Type':'application/x-www-form-urlencoded',Accept:'text/html'},body:data.toString()})
          .then(function(){ form.innerHTML='<p class="rnews__ok" style="margin:0;font-weight:600">Thanks \u2014 you\u2019re subscribed.</p>'; })
          .catch(function(){ form.innerHTML='<p class="rnews__ok" style="margin:0;font-weight:600">Thanks \u2014 we\u2019ll be in touch.</p>'; });
      });
    });
  })();
